import { AnalyticsEvents } from 'enums';
import { DataLayerEvent, QueryStringEvent } from 'interfaces';

export const captureEvent = (
  eventName: AnalyticsEvents,
  payload: Partial<DataLayerEvent | QueryStringEvent> = {},
): void => {
  if (window.dataLayer && process.env.REACT_APP_ENABLE_ANALYTICS === 'true') {
    const eventData: DataLayerEvent = {
      event: eventName,
      ...payload,
      event_time: payload.event_time ?? new Date().toISOString(),
    };
    window.dataLayer.push(eventData);
  }
};
